export enum PageType {
  Public = 'public',
  Private = 'private',
}
